import { gql } from '@apollo/client';

export const GET_APPLICATION_VIEW_FILTER_DATA = gql`
  query {
    getFundingSourceConfiguration {
      mapping
    }
    programmeChoiceMetadata {
      departments {
        value
        label
      }
      entryYearList {
        value
        label
      }
      rpgJoinPhdPartnerList {
        value
        label
      }
      prgCollabPhdPartnerList {
        value
        label
      }
    }

    getGSAssigneeList {
      assigneeList {
        netId
        displayName
      }
    }
  }
`;
